import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: 0,
      overflow: 'visible',
    },
    billedContainer: {
      overflow: 'visible',
    },
    backContainer: {
      display: 'flex',
      cursor: 'pointer',
      fontSize: 14,
      fontWeight: 600,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 20,
      },
    },
    backChevron: {
      fontSize: 18,
      fontWeight: 600,
      marginRight: 8,
      color: colorVariables.navy,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 20,
        marginTop: 5,
      },
    },
    currentPlanText: {
      fontSize: 16,
      fontWeight: 600,
    },
    subHeader1: {
      marginBottom: 10,
      color: colorVariables.userNavy,
      textAlign: 'center',
      fontSize: 32,
      fontWeight: 700,
    },
    subHeader2: {
      fontSize: 16,
      fontWeight: 600,
      color: colorVariables.grey60,
      textAlign: 'center',
      marginBottom: 10,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 14,
        fontWeight: 400,
        marginTop: 14,
      },
    },
    billedSwitch: {
      textAlign: 'center',
      marginBottom: 20,
    },
    billedMonthly: {
      fontSize: 14,
      fontWeight: 400,
      color: colorVariables.grey60,
    },
    billedAnnually: {
      fontSize: 14,
      fontWeight: 400,
      color: colorVariables.grey60,
    },
    billedActive: {
      fontWeight: 700,
      color: colorVariables.navy,
    },
    save20: {
      color: '#40C369',
    },
    card: {
      borderRadius: 20,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid rgba(0,0,0,0.1)',
    },
    cardContent: {
      padding: '0 !important',
      textAlign: 'left',
    },
    bodyContainer: {
      textAlign: 'left',
      padding: 24,
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: 8,
      },
    },
    cardFeatureTitle: {
      fontWeight: 700,
      fontSize: 18,
      marginBottom: theme.spacing(1),
      color: colorVariables.navy,
      textTransform: 'capitalize',
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 14,
        fontWeight: 500,
      },
    },
    track: {
      backgroundColor: colorVariables.steelGrey,
      opacity: 1,
    },
    thumb: {
      backgroundColor: colorVariables.white,
      width: 20,
      height: 20,
    },
    checked: {
      '&.MuiSwitch-switchBase + .MuiSwitch-track': {
        backgroundColor: '#44B5E6',
        opacity: 1,
      },
    },
    dropdown: {
      zIndex: 99,
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
      },
    },
    item: {
      padding: 0,
      [theme.breakpoints.down(Sizes.mobile)]: {
        whiteSpace: 'break-spaces',
      },
    },
    inputField: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      height: 48,
      backgroundColor: colorVariables.white,
      borderRadius: 4,
      border: `1px solid ${colorVariables.steelGrey}`,
      color: colorVariables.navy,
      fontSize: 16,
      padding: '0 20px',
      cursor: 'pointer',
      '&:hover': {
        border: `1px solid ${colorVariables.blue}`,
      },
      '& strong': {
        fontWeight: 700,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: '0 8px',
        height: 70,
      },
    },
    icon: {
      color: colorVariables.navy,
      fontSize: 16,
    },
    checkIcon: {
      color: '#40C369',
      marginRight: theme.spacing(1),
    },
    closeIcon: {
      color: '#FA6767',
      marginRight: theme.spacing(1),
    },
    active: {
      border: `1px solid ${colorVariables.blue}`,
    },
    selectItem: {
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 16,
      padding: '10px 20px',
      position: 'relative',
      color: colorVariables.grey80,
      '& strong': {
        fontWeight: 700,
        display: 'block',
      },
    },
    subText: {
      fontWeight: 600,
    },
    recommendedItem: {
      background: '#FFF6D3',
    },
    recommendedChipTable: {
      backgroundColor: '#F96767',
      color: '#fff',
      fontWeight: 700,
      fontSize: 11,
      position: 'absolute',
      right: 10,
      top: 10,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 10,
        height: '20px',
      },
    },
    recommendedChipIcon: {
      color: '#fff',
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 12,
      },
    },
    selectedItem: {
      display: 'flex',
    },
    unlimitedCard: {
      marginTop: 20,
    },
    unlimitedUpper: {
      backgroundColor: '#40C36933',
      padding: '5px 24px',
    },
    freeUpper: {
      backgroundColor: '#F9676733',
      padding: '5px 24px',
    },
    unlimitedCardFeatureTitle: {
      fontWeight: 600,
      fontSize: 16,
      color: colorVariables.navy,
      '& strong': {
        fontWeight: 700,
      },
    },
    listItemIcon: {
      '&.MuiListItemIcon-root': {
        minWidth: 'auto',
      }
    },
    listItemWrapper: {
      backgroundColor: '#40C3690D',
      padding: '5px 24px',
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: '5px 10px',
      },
    },
    freeListItemWrapper: {
      backgroundColor: '#F967670D',
      padding: '5px 24px',
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: '5px 10px',
      },
    },
    listItemText: {
      margin: 0,
    },
    paymentContainer: {
      marginTop: 20,
      textAlign: 'center',
    },
    secureText: {
      marginTop: 10,
      fontWeight: 400,
      fontSize: 16,
      color: colorVariables.grey80,
    },
    modalBox: {
      padding: 0,
      width: '70%',
      height: '600px',
      overflow: 'hidden',
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '90%',
        height: '450px',
        '& div': {
          padding: 0,
          margin: 0,
          maxWidth: '100%',
        },
      },
    },
    dialog: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      [theme.breakpoints.down(Sizes.mobile)]: {
        margin: 0,
      },
    },
  }),
);
